module.exports = __webpack_public_path__ + "static/media/choithramsRecipeThree.25567e7d.png";